export enum SiteType {
  Unknown = 0,
  S1 = 1,
  CustomerWeb = 2,
  EnergyObjective = 3,
}
